interface Navigator {
  globalPrivacyControl: boolean | undefined;
}

interface Window {
  OnetrustActiveGroups: string | undefined;
  __ucpConsentOptions: { targetingCategoryIdList?: string } | undefined;
  OptanonWrapper: (() => void) | undefined;
}

(function () {
  var consentUrl = "/api/client-monitor/consent";
  var options = window.__ucpConsentOptions || {};
  var targetingCategoryIdList: string[] = (
    options.targetingCategoryIdList || "C0004"
  )
    .split(",")
    .map(function (id: string) {
      return id.trim();
    })
    .filter(function (id: string) {
      return id.length > 0;
    });

  function send(url: string, data: object): void {
    var blob = new Blob([JSON.stringify(data)], { type: "application/json" });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
        keepalive: true,
      });
    }
  }

  // GPC client-side: only report when navigator.globalPrivacyControl === true.
  // undefined = browser does not expose it — do not treat as false.
  var gpcOn = navigator.globalPrivacyControl === true;
  // Tracks the last state actually reported so we never resend an unchanged state, and so
  // fallback() can tell whether a real state was already reported before polling finished.
  var hasReportedOptOut: boolean | null = null;

  function targetingOptOutFrom(active: string): boolean {
    return targetingCategoryIdList.some(function (id) {
      return active.indexOf(id) === -1;
    });
  }

  function reportTargetingOptOut(targetingOptOut: boolean): void {
    var consent_modified =
      hasReportedOptOut !== null && hasReportedOptOut !== targetingOptOut;
    hasReportedOptOut = targetingOptOut;
    send(consentUrl, {
      consent_state: targetingOptOut ? "opted-out" : "opted-in",
      consent_modified,
      gpc_js: gpcOn ? true : null,
    });
  }

  function fallback(): void {
    // Bail out if OneTrustGroupsUpdated already reported a state while we were polling.
    if (hasReportedOptOut !== null) {
      return;
    }
    if (gpcOn) {
      // OneTrust never became ready: fall back to the raw GPC signal.
      hasReportedOptOut = true;
      send(consentUrl, {
        consent_state: "opted-out",
        consent_modified: false,
        gpc_js: true,
      });
    } else {
      send(consentUrl, {
        consent_state: "default",
        consent_modified: false,
      });
    }
  }

  // Total wait before falling back to the GPC/default guess if OneTrust never becomes ready.
  // ~10s should cover typical load times, but slow networks (mobile, high-latency CDN) could
  // still exceed it — tune this if production reports show the fallback firing too early.
  var FALLBACK_TIMEOUT_MS = 10000;
  window.setTimeout(fallback, FALLBACK_TIMEOUT_MS);

  // OneTrust: targetingCategoryIdList (default C0004/Targeting) is the only opt-outable category relevant here.
  window.addEventListener(
    "OneTrustGroupsUpdated",
    function (e: Event) {
      var active: string =
        window.OnetrustActiveGroups || (e as CustomEvent).detail || "";
      var targetingOptOut = targetingOptOutFrom(active);
      if (hasReportedOptOut === targetingOptOut) {
        return;
      }
      reportTargetingOptOut(targetingOptOut);
    },
    { passive: true },
  );
})();
